export const GENDERS = {
  male: 'male',
  female: 'female'
}

export const GENDER_OPTIONS = [
  { id: GENDERS.male, name: 'Мужской' },
  { id: GENDERS.female, name: 'Женский' }
]

export const COOKIE_NAMES = {
  pauseProfileModalWindow: 'pauseProfileModalWindow',
  hasCookiesProcessingAgree: 'hasCookiesProcessingAgree',
  noShowAppModal: 'noShowAppModal'
}
